import React from "react";
import Title from "../../../components/Title/Title";


const CameraReady2027page = () => {
    return (
        <div>
            <Title>Camera-ready Instructions</Title>
            <p>[COMING SOON] </p>

        </div>
    );
};

export default CameraReady2027page;
